/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  projectValueFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
    .controller('contractAwardDateFilterController', ['$scope',
      function ($scope) {
        $scope.componentName = "contractAwardDateFilter";

        $scope.resetFilter = function () {
          delete $scope.criteria["contractAwardDateFrom"];
          delete $scope.criteria["contractAwardDateTo"];
          delete $scope.criteria["contractAwardDateToRaw"];
        };

        $scope.removeProjectValueFilter = function () {
          $scope.resetFilter();
          $scope.$parent.removeFilter("#contractAwardDateFilter");
        };

//        $scope.endDate = {};

//        $scope.$watch("endDate.firstDay", function(){
//          // when the end date changes, find the last date of the same month
//          // do this by creating a new date, adding a month and subtracting a day
//          if($scope.endDate.firstDay){
//            var firstDayOfEndMonth = $scope.endDate.firstDay;
//            $scope.criteria.contractAwardDateTo = new Date(firstDayOfEndMonth.getFullYear(), firstDayOfEndMonth.getMonth()+1, 0 );
//          }
//
//        });

        $scope.$watch("criteria.contractAwardDateToRaw", function (newVal, oldVal) {
          // wait until there is a value here
          if (!newVal) return;

          // I can't understand why the date is sometimes returned as a string but
          // this is screwing up the internal processing of the datePicker control
          // Hypothesis -  when the search criteria are serialised to the server, 
          // the dates are converted into strings. then when the search is sent back
          // and bound to the filters, they  are still strings
          if (typeof $scope.criteria.contractAwardDateToRaw === 'string') (
            $scope.criteria.contractAwardDateToRaw  =  new Date($scope.criteria.contractAwardDateToRaw)
          );

          // when the end date changes, find the last date of the same month
          // do this by creating a new date, adding a month and subtracting a day
          if ($scope.criteria.contractAwardDateToRaw) {
            var firstDayOfEndMonth = $scope.criteria.contractAwardDateToRaw;
            $scope.criteria.contractAwardDateTo = new Date(firstDayOfEndMonth.getFullYear(), firstDayOfEndMonth.getMonth() + 1, 0);
          }

        });

        $scope.$watch("criteria.contractAwardDateFrom", function (newVal, oldVal) {
          // wait until there is a value here
          if (!newVal) return;

          // I can't understand why the date is sometimes returned as a string but
          // this is screwing up the internal processing of the datePicker control
          // Hypothesis -  when the search criteria are serialised to the server, 
          // the dates are converted into strings. then when the search is sent back
          // and bound to the filters, they  are still strings
          // -- try a simple conversion
          if (typeof $scope.criteria.contractAwardDateFrom === 'string') (
            $scope.criteria.contractAwardDateFrom  =  new Date($scope.criteria.contractAwardDateFrom)
          );
        });


        $scope.clearAwardDateFrom =  function() {
          $scope.criteria.contractAwardDateFrom = null;

          // set the element pristine
          verifyFormState();
        };
        $scope.clearAwardDateTo = function () {
          $scope.criteria.contractAwardDateToRaw = null;
          $scope.criteria.contractAwardDateTo = null;

          // set the form pristine
          verifyFormState();
        };

        var verifyFormState = function(){
          if(!$scope.criteria.contractAwardDateFrom  && !$scope.criteria.contractAwardDateTo){
            $scope.contractAwardDateFilterForm.$setPristine();
          }
        };

        $scope.showInvalidMessage = function () {
          var showMessage;
          if (!$scope.contractAwardDateFilterForm) return false;

          // The current date entry control handles invalid dates internally - so it is not necessary to process
          // this here. A future version might  need more handling - so I am leaving this here.
          // Instead we have rather simpler pristine detection which only shows the mssage if the user has
          // interacted with the form then set both dates to null
          showMessage = ($scope.contractAwardDateFilterForm.$dirty
              && !$scope.criteria.contractAwardDateFrom
              && !$scope.criteria.contractAwardDateTo);

          // showMessage is also true if both dates are set and the from date is larger than the to date
              showMessage = showMessage || ($scope.criteria.contractAwardDateFrom > $scope.criteria.contractAwardDateTo)

              //($scope.criteria.contractAwardDateFrom &&
              //    $scope.criteria.contractAwardDateTo &&
              //    $scope.criteria.contractAwardDateFrom >= $scope.criteria.contractAwardDateTo);


          $scope.contractAwardDateFilterForm.$setValidity("$valid", !(showMessage || $scope.contractAwardDateFilterForm.$pristine))

          // this is not very nice looking logic - it is caused by the either/or/both
          // nature of the date range filter

//          var showMessage = false
//          if (!angular.isNumber($scope.criteria.contractAwardDateFrom) && $scope.criteria.contractAwardDateFrom != "")
//            showMessage = true;
//
//          if(!angular.isNumber($scope.criteria.contractAwardDateTo) && $scope.criteria.contractAwardDateTo != "" )
//            showMessage = true;
//
//          if (!$scope.criteria.contractAwardDateTo && !$scope.criteria.contractAwardDateFrom)
//            showMessage = true;
//
//          if (angular.isNumber($scope.criteria.contractAwardDateFrom) && !$scope.criteria.contractAwardDateTo)
//            showMessage = false;
//
//          if (angular.isNumber($scope.criteria.contractAwardDateTo) && !$scope.criteria.contractAwardDateFrom)
//            showMessage = false;
//
//          if(angular.isNumber($scope.criteria.contractAwardDateFrom)
//              && angular.isNumber($scope.criteria.contractAwardDateTo)
//              && $scope.criteria.contractAwardDateTo <= $scope.criteria.contractAwardDateFrom)
//            showMessage = true;
//
//          if ($scope.contractAwardDateFilterForm.$pristine)
//            showMessage = false;
//
//
//          $scope.contractAwardDateFilterForm.$setValidity("$valid", !(showMessage || $scope.contractAwardDateFilterForm.$pristine))
         return showMessage;
        };



        $scope.ignoreKeypress = function (e) {
          e.preventDefault();
          return false;
        }
      }])
    .directive('contractAwardDateFilter', ['$compile',
      function ($compile) {
        return {
          replace:     true,  // replace the placeholder element with the template
          restrict:    'A',   // usage: <div projectNameFilter />
          templateUrl: "../app-ds3/search/queryBuilder/filters/contractAwardDateFilter.tmpl.html",

          link: function ($scope, iElement, iAttrs) {
            if ($scope.criteria.contractAwardDateFrom || $scope.criteria.contractAwardDateTo) {
              $scope.contractAwardDateFilterForm.$setDirty();
            }
          },

          controller: 'contractAwardDateFilterController'
        };
      }]);
//------------------------------------------------------------------------

